(() => {
  const updateQuantity = (button, direction) => {
    const quantity = button.closest('[data-product-qty]');
    const input = quantity?.querySelector('input[type="number"]');
    if (!input) return;

    const minimum = Number.isFinite(Number(input.min)) ? Number(input.min) : 1;
    const maximum = input.max !== '' && Number.isFinite(Number(input.max)) ? Number(input.max) : Infinity;
    const step = input.step !== '' && Number(input.step) > 0 ? Number(input.step) : 1;
    const current = Number.isFinite(Number(input.value)) ? Number(input.value) : minimum;
    const next = Math.min(maximum, Math.max(minimum, current + (direction * step)));

    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const minusButton = event.target.closest('[data-product-qty-minus]');
    const plusButton = event.target.closest('[data-product-qty-plus]');

    if (minusButton || plusButton) {
      event.preventDefault();
      updateQuantity(minusButton || plusButton, plusButton ? 1 : -1);
      return;
    }

    const thumbnail = event.target.closest('[data-product-thumb]');
    if (thumbnail) {
      const product = thumbnail.closest('[data-product-root]') || document;
      const mainImage = product.querySelector('[data-product-main-image]');
      if (mainImage && thumbnail.dataset.image) mainImage.src = thumbnail.dataset.image;
      thumbnail.parentElement?.querySelectorAll('[data-product-thumb]').forEach((button) => button.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
      return;
    }

    const tab = event.target.closest('[data-product-tab]');
    if (!tab) return;

    const tabs = tab.closest('[data-product-tabs]');
    if (!tabs) return;

    tabs.querySelectorAll('[data-product-tab]').forEach((button) => button.classList.remove('is-active'));
    tabs.querySelectorAll('[data-product-panel]').forEach((panel) => { panel.hidden = true; });
    tab.classList.add('is-active');

    const panel = tabs.querySelector(`[data-product-panel="${tab.dataset.productTab}"]`);
    if (panel) panel.hidden = false;
  });
})();
